/* eslint-disable no-unused-vars */
/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { TextField } from '@material-ui/core';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  tabHighLigther,
  autoFormateDate,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
import createIcon from '../../../../assets/images/feather-settings.svg';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  checkQuarterValidation,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getGenerateNicheReport,
  getNicheRptAvailableMsg,
  getPlanTypeRadioBoxValue,
  getRebateProgramDropdownList,
  handleErrorMessagesNicheReport,
  setDataNicheReportScreenTab,
} from '../Store/Actions';
import {
  leftRebateProgramHead,
  rightRebateProgramHead,
} from './gridComponents/tableHead';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

const RequestDataNicheReportComponent = () => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.DataNicheReportReducer?.errorMessagesInRedux
  );
  const dataNicheReportScreenTabRedux = useSelector(
    (state) =>
      state?.sharedState?.DataNicheReportReducer?.dataNicheReportScreenObj
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const leftGridRef = useRef();
  const rightGridRef = useRef();
  const dispatch = useDispatch();
  // variable deceleration
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [fullScreenViewLeftGrid, setFullScreenViewLeftGrid] = React.useState(
    dataNicheReportScreenTabRedux?.fullScreenViewLeftGrid || false
  );
  const [fullScreenViewRightGrid, setFullScreenViewRightGrid] = React.useState(
    dataNicheReportScreenTabRedux?.fullScreenViewRightGrid || false
  );
  const [leftGridAPI, setLeftGridAPI] = useState();
  const [rightGridData, setRightGridData] = useState(
    dataNicheReportScreenTabRedux?.rightRowSelected || []
  );
  const [leftRowSelected, setLeftRowSelected] = useState([]);
  const [rightRowSelected, setRightRowSelected] = useState(
    dataNicheReportScreenTabRedux?.rightRowSelected || []
  );
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [warningAlertMsg, setWarningAlertMsg] = React.useState('');
  const [state, setState] = React.useState(
    dataNicheReportScreenTabRedux?.state
      ? dataNicheReportScreenTabRedux.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          selectedValue: 'Claim',
          quarterValue: '',
        }
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
      );
    }
  }, []);
  // on scroll default top level
  React.useEffect(() => {
    handleScrollToEvent();
    getPlanTypeRadioBoxValue().then((res) => {
      const planList =
        res?.length > 0 &&
        res?.map((obj) => {
          return {
            name:
              obj?.codeValueID?.codeValue === 'FD'
                ? 'Medicaid'
                : obj.shortDescription,
            value: obj.codeValueID.codeValue,
          };
        });
      setPlanTypeOptions(planList);
    });
  }, []);
  // set common dropdown list after calling API service
  React.useEffect(() => {
    getRebateProgramDropdownList(state?.planTypeCd).then((res) => {
      let list = [];
      if (
        res?.status === constantMessageData.STATUS_MSG &&
        res?.message === constantMessageData.SUCCESS_MSG
      ) {
        if (!_.isEmpty(res.data)) {
          list = _.map(res.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    });
  }, [state?.planTypeCd]);
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/requestDataNicheReport', true);
    } else {
      tabHighLigther('/requestDataNicheReport', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // handle after call service show success and error message
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    setSuccessMessage([]);

    setState({ ...state, [name]: value });
    dispatch(
      setDataNicheReportScreenTab({
        ...dataNicheReportScreenTabRedux,
        state: {
          ...state,
          [name]: value,
        },
      })
    );
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    setSuccessMessage([]);
    let localErr = errorMessagesFromRedux || [];
    if (type === 'quarterValue') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          dispatch(
            setDataNicheReportScreenTab({
              ...dataNicheReportScreenTabRedux,
              state: {
                ...state,
                quarterValue: autoFormateDate(value?.toUpperCase()),
              },
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    dispatch(handleErrorMessagesNicheReport([...new Set(localErr)]));
  };
  const onGridReadyLeftGrid = (params, deselect) => {
    if (!deselect) {
      setLeftGridAPI(params);
      if (leftRowSelected?.length > 0) {
        leftRowSelected.forEach((elem) => {
          if (elem?.rebateProgramCd) {
            params.api.forEachNode(
              // eslint-disable-next-line eqeqeq
              (node) =>
                node?.data?.rebateProgramCd == elem.rebateProgramCd &&
                node?.setSelected(true)
            );
          }
        });
      }
    } else {
      // eslint-disable-next-line no-unused-expressions
      params?.api?.deselectAll();
      setLeftGridAPI(params);
    }
  };
  const onGridReadyRightGrid = (params) => {
    if (rightRowSelected?.length > 0) {
      rightRowSelected.forEach((elem) => {
        if (elem?.rebateProgramCd) {
          params.api.forEachNode(
            // eslint-disable-next-line eqeqeq
            (node) =>
              node?.data?.rebateProgramCd == elem.rebateProgramCd &&
              node?.setSelected(true)
          );
        }
      });
    }
  };
  const onSelectionChangedLeft = (params) => {
    const selectedRowNodes = params.api.getSelectedNodes();
    const array = [];
    selectedRowNodes.forEach((elem) => {
      array.push(elem.data);
    });
    setLeftRowSelected(array);
  };
  const onSelectionChangedRight = (params) => {
    const selectedRowNodes = params.api.getSelectedNodes();
    const array = [];
    selectedRowNodes.forEach((elem) => {
      array.push(elem.data);
    });
    setRightRowSelected(array);
  };
  // click on left Grid full screen icon after call
  const handleFullScreenViewLeftGrid = () => {
    setFullScreenViewLeftGrid(!fullScreenViewLeftGrid);
    setFullScreenViewRightGrid(false);

    dispatch(
      setDataNicheReportScreenTab({
        ...dataNicheReportScreenTabRedux,
        fullScreenViewLeftGrid: !fullScreenViewLeftGrid,
        fullScreenViewRightGrid: false,
      })
    );
  };
  // click on right Grid full screen icon after call
  const handleFullScreenViewRightGrid = () => {
    setFullScreenViewRightGrid(!fullScreenViewRightGrid);
    setFullScreenViewLeftGrid(false);
    dispatch(
      setDataNicheReportScreenTab({
        ...dataNicheReportScreenTabRedux,
        fullScreenViewLeftGrid: false,
        fullScreenViewRightGrid: !fullScreenViewRightGrid,
      })
    );
  };

  const actionNDCsMove = async (moveFrom, rows, empty = false) => {
    let errorHandleInMove = errorMessagesFromRedux || [];

    let leftList = [];
    let rightList = [];
    if (moveFrom === 'leftToRight') {
      if (!_.isEmpty(rebateProgramList) && leftRowSelected.length > 0) {
        const listLeft = leftRowSelected;

        let found = false;
        rightGridData?.length > 0 &&
          rightGridData.forEach((element) => {
            if (listLeft?.length > 0) {
              if (
                listLeft.filter(
                  (el) => el.rebateProgramCd == element.rebateProgramCd
                )?.length > 0
              ) {
                found = true;
              }
            }
          });

        if (!found) {
          rightList = rightGridData.concat(listLeft);
          errorHandleInMove = errorHandleInMove.filter(
            (item) =>
              item.field !== 'alreadyPresentRebateProgramInRight' &&
              item.field !== 'RebateProgramNotSelected'
          );
          setLeftRowSelected([]);
          onGridReadyLeftGrid(leftGridAPI, true);
        } else {
          errorHandleInMove = errorHandleInMove.filter(
            (item) => item.field !== 'alreadyPresentRebateProgramInRight'
          );
          errorHandleInMove.push({
            field: 'alreadyPresentRebateProgramInRight',
            errorType: 'alreadyPresentRebateProgramInRight',
            message: constantMessageData.REBATE_PROGRAM_ALREADY_FOR_STC_NOT,
          });
          rightList = rightGridData;
        }
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field !== 'RebateProgramNotSelected'
        );
        errorHandleInMove.push({
          field: 'RebateProgramNotSelected',
          errorType: 'RebateProgramNotSelected',
          message: constantMessageData.ERR_SELECT_REBATE_PROGRAM_REMOVE,
        });
        leftList = rebateProgramList;
        rightList = rightGridData;
      }
    }
    if (moveFrom === 'AllLeftToRight') {
      setLeftRowSelected([]);
      setRightRowSelected([]);
      if (!_.isEmpty(rebateProgramList)) {
        leftList = [];

        const found = false;

        const arrayAlready = [];
        const differentNDC = [];

        rightGridData?.length > 0 &&
          rightGridData.forEach((element) => {
            if (rebateProgramList?.length > 0) {
              if (
                rebateProgramList.filter(
                  (el) => el.rebateProgramCd == element.rebateProgramCd
                )?.length > 0
              ) {
                arrayAlready.push(element);
              } else {
                differentNDC.push(element);
              }
            }
          });

        if (arrayAlready?.length > 0) {
          rightList = rebateProgramList;
        } else {
          rightList = rebateProgramList;
        }

        rightList = [...differentNDC, ...rightList];
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field !== 'RebateProgramNotSelected'
        );
        setLeftRowSelected([]);
        onGridReadyLeftGrid(leftGridAPI, true);
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field !== 'RebateProgramNotSelected'
        );
        errorHandleInMove.push({
          field: 'RebateProgramNotSelected',
          errorType: 'RebateProgramNotSelected',
          message: constantMessageData.ERR_SELECT_REBATE_PROGRAM_REMOVE,
        });
        leftList = rebateProgramList;
        rightList = rightGridData;
      }
    }
    if (moveFrom === 'AllRightToLeft') {
      setRightRowSelected([]);
      if (!_.isEmpty(rightGridData)) {
        rightList = [];
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field !== 'RebateProgramNotSelected'
        );
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field !== 'RebateProgramNotSelected'
        );
        errorHandleInMove.push({
          field: 'RebateProgramNotSelected',
          errorType: 'RebateProgramNotSelected',
          message: constantMessageData.ERR_SELECT_REBATE_PROGRAM_REMOVE,
        });
        leftList = rebateProgramList;
        rightList = rightGridData;
      }
    }
    if (moveFrom === 'rightToLeft') {
      if (!_.isEmpty(rightGridData) && rightRowSelected.length > 0) {
        errorHandleInMove = errorHandleInMove.filter(
          (item) =>
            item.field !== 'alreadyPresentRebateProgramInRight' &&
            item.field !== 'RebateProgramNotSelected'
        );
        rightList = rightGridData.filter(
          (ar) =>
            !rightRowSelected.find(
              (rm) => rm.rebateProgramCd === ar.rebateProgramCd
            )
        );
        setLeftRowSelected([]);
        setRightRowSelected([]);
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field !== 'RebateProgramNotSelected'
        );
        errorHandleInMove.push({
          field: 'RebateProgramNotSelected',
          errorType: 'RebateProgramNotSelected',
          message: constantMessageData.ERR_SELECT_REBATE_PROGRAM_REMOVE,
        });
        leftList = rebateProgramList;
        rightList = rightGridData;
      }
    }
    dispatch(
      setDataNicheReportScreenTab({
        ...dataNicheReportScreenTabRedux,
        rightRowSelected: rightList,
      })
    );
    setRightGridData(rightList);
    dispatch(handleErrorMessagesNicheReport([...new Set(errorHandleInMove)]));
  };
  const handleGetNicheReportAvailableAlert = async (params) => {
    const resultData = await getNicheRptAvailableMsg(params);
    if (
      resultData?.status === '001' &&
      resultData?.data?.includes('Data Niche Claim files already exist')
    ) {
      setOpenConfirm(true);
      dispatch(handleErrorMessagesNicheReport([]));
      setSuccessMessage([]);
    } else {
      popupOnConfirmYes();
    }
  };
  const handleProcess = async () => {
    setSuccessMessage([]);
    if (state?.selectedValue === 'Provider') {
      dispatch(handleErrorMessagesNicheReport([]));
      const tempObj = {
        fileName: 'DN_Provider.txt',
      };
      handleGetNicheReportAvailableAlert(tempObj);
    } else {
      let localErr = errorMessagesFromRedux || [];

      if (
        state?.quarterValue &&
        !_.isEmpty(state?.quarterValue) &&
        !_.isNaN(state?.quarterValue)
      ) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(state?.quarterValue)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );

          if (rightGridData?.length > 0) {
            localErr = localErr.filter(
              (item) =>
                item.field !== 'alreadyPresentRebateProgramInRight' &&
                item.field !== 'RebateProgramNotSelected'
            );
            if (rightGridData?.length === 1) {
              setWarningAlertMsg(
                `Data Niche Claim file already exist in In file location for the following rebate program code ${rightGridData[0]?.rebateProgramCd}. Do you want to overwrite the existing file.?`
              );
            } else {
              setWarningAlertMsg(
                `Data Niche Claim files already exist in In file location for the following rebate program codes ${rightGridData?.map(
                  (item) => item.rebateProgramCd
                )}. Do you want to overwrite the existing files.?`
              );
            }
            const tempObj = {
              fileName: '',
            };
            const quarterData = state?.quarterValue?.split('Q');
            const quarterVal = `${
              quarterData[quarterData?.length - 1]
            }${quarterData[0].substring(0, 1)}`;
            for (let i = 0; i < rightGridData?.length; i += 1) {
              tempObj.fileName = `DN_Claim_${rightGridData[i].rebateProgramCd}_${quarterVal}.txt`;
              const result = await handleGetNicheReportAvailableAlert(tempObj);
            }
          } else {
            localErr = localErr.filter(
              (item) => item.field !== 'RebateProgramNotSelected'
            );
            localErr.push({
              field: 'RebateProgramNotSelected',
              errorType: 'RebateProgramNotSelected',
              message: constantMessageData.ERR_SELECT_REBATE_PROGRAM_REMOVE,
            });
          }
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
          handleScrollToEvent();
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
        handleScrollToEvent();
      }
      dispatch(handleErrorMessagesNicheReport([...new Set(localErr)]));
    }
  };
  const popupOnConfirmYes = async () => {
    setOpenConfirm(false);
    let newObj = {};
    if (state?.selectedValue === 'Provider') {
      newObj = {
        isNRClaim: false,
        userName: logInUser,
      };
    } else {
      newObj = {
        isNRClaim: true,
        quater: state?.quarterValue,
        rpc: rightGridData.map((item) => {
          return item.rebateProgramCd;
        }),
        userName: logInUser,
      };
    }
    const result = await getGenerateNicheReport(newObj);
    if (
      result?.status === '001' &&
      result?.data?.includes('Niche Report submitted')
    ) {
      setSuccessMessage([constantMessageData.JOB_COMPLETE]);
      dispatch(handleErrorMessagesNicheReport([]));
    } else {
      dispatch(
        handleErrorMessagesNicheReport([
          constantMessageData.FAIL_PROCESSING_REQUEST,
        ])
      );
      setSuccessMessage([]);
    }
  };
  return (
    <div
      className="tabs-container tBillPanel custom-check"
      data-testid="request-data-niche-report"
    >
      <CommonModal
        open={openConfirm}
        className="dialogPanel custom-check dialog-600"
        data-testid="common-modal"
        viewAction
        viewHeader
        modalTitle="Request Data Niche Report"
        okTitle="Yes"
        closeTitle="No"
        removeClassName
        childrenComponent={
          <>
            <div>
              {state?.selectedValue === 'Provider'
                ? constantMessageData.DATA_NICHE_ALREADY_EXIST_MSG
                : warningAlertMsg}
            </div>
          </>
        }
        onOk={() => {
          popupOnConfirmYes();
        }}
        onClose={() => {
          setOpenConfirm(!openConfirm);
        }}
      />
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Tasks" parent2="Data Niche Report" />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            errorMessagesFromRedux?.length > 0
              ? _.map(errorMessagesFromRedux, (l) => l.message)
              : []
          ),
        ]}
      />
      {errorMessagesFromRedux && errorMessagesFromRedux.length === 0 && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}

      {!fullScreenViewLeftGrid && !fullScreenViewRightGrid && (
        <>
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="req-prg-plantype"
                id="radio-button-for-rcdd_id"
                labelName="Plan Type"
                required
                optionList={planTypeOptions}
                defaultValue={state && state?.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4 frr-two-col-radio ">
              <RadioGroupComponent
                data-testid="repotyOption"
                id="repotyOption"
                labelName="Report Option"
                required
                optionList={[
                  { name: 'Claim', value: 'Claim' },
                  { name: 'Provider', value: 'Provider' },
                ]}
                defaultValue={state && state?.selectedValue}
                filterAction={(e) => handleOnChangeEvent(e, 'selectedValue')}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            {state?.selectedValue === 'Claim' && (
              <div className="col-4 frr-two-col-radio">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Quarter<span className="mandatory"> *</span>
                  </legend>
                  <div className="form-wrapper p-3">
                    <div className="mui-custom-form with-select field-xl no-lbl">
                      <TextField
                        id="req_data_niche_rpt_quaterss"
                        label="InvoiceStartQtr"
                        data-testid="req-prgm-strqtr"
                        required
                        fullWidth
                        value={state?.quarterValue}
                        onChange={(e) =>
                          handleOnChangeEvent(e?.target.value, 'quarterValue')
                        }
                        placeholder=""
                        inputProps={{
                          maxLength: 6,
                          id: 'req_data_niche_rpt_quater',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="quarterValue"
                        onBlur={(e) =>
                          handleOnblurEvent('quarterValue', e.target.value)
                        }
                        className={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'quarter' ? 'mandate-fields' : null
                              )
                            : null
                        }
                        helperText={[
                          ...new Set(
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'quarter' ? l.message : null
                                )
                              : null
                          ),
                        ]}
                        error={[
                          ...new Set(
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'quarter' ? l.message : null
                                )
                              : null
                          ),
                        ]}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            )}
          </div>
          <div className="col-sm-3 btn-wrapper" style={{ float: 'right' }}>
            <Button
              className="btn-success same-font-family frr-btn-width-17 mt-3"
              type="button"
              style={{ float: 'right' }}
              onClick={handleProcess}
              data-testid="handleProcess"
              disabled={isEnablebyRole}
            >
              <img className="manufactureImg" alt="" src={createIcon} />
              Process
            </Button>
          </div>
        </>
      )}
      {state?.selectedValue === 'Claim' && (
        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk"
        >
          <div className="ndcsTableSection FRR-custom-table">
            {!fullScreenViewRightGrid && (
              <div
                className={`ndcTable ndcTableLeft ${
                  fullScreenViewLeftGrid ? 'col-12' : ''
                }`}
              >
                <>
                  <TableGridWithFeatures
                    ref={leftGridRef}
                    data-testid="ndcleft-stc-table"
                    rowSelection="multiple"
                    frameworkComponents={{
                      TextBoxRender: (cellInfo) => {
                        const name = cellInfo?.value;

                        if (name && name.length > 20) {
                          return (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="labeler-tooltip">{name}</Tooltip>
                              }
                            >
                              <div>{name}</div>
                            </OverlayTrigger>
                          );
                        }
                        return <div>{name}</div>;
                      },
                    }}
                    rowMultiSelectWithClick={false}
                    fullScreenView={fullScreenViewLeftGrid}
                    handleFullScreenViewClick={handleFullScreenViewLeftGrid}
                    gridHeight="50vh"
                    rowData={rebateProgramList}
                    columnDefs={leftRebateProgramHead}
                    exportFile
                    animateRows
                    sideBar={false}
                    fileName="Rebate Programs"
                    singleClickEdit
                    gridCall={onGridReadyLeftGrid}
                    navigateToNextCell={navigateToNextCell}
                    tabToNextCell={tabToNextCell}
                    onSelectionChanged={onSelectionChangedLeft}
                    enterMovesDown
                    suppressCellFocus
                    onCellFocused={onCellFocused}
                  />
                </>
              </div>
            )}
            {!fullScreenViewLeftGrid && !fullScreenViewRightGrid && (
              <div className="ndcTableBtn2 RightArrow">
                <Button
                  id="ndcTableBtnId"
                  className="btn-primary"
                  onClick={() => actionNDCsMove('leftToRight', 'LeftGridData')}
                  tabIndex={0}
                  aria-label="RightArrow"
                >
                  <i
                    className="fa fa-light fa-caret-right"
                    aria-hidden="true"
                  />
                  <span className="hide-elm">Right Arrow</span>
                </Button>
                <Button
                  id="ndcTableBtnIdALTR AllLeftArrow"
                  className="btn-primary"
                  onClick={() => actionNDCsMove('AllLeftToRight', null)}
                  tabIndex={0}
                  aria-label="AllLeftArrow"
                >
                  <i className="fa fa-light fa-forward" aria-hidden="true" />
                  <span className="hide-elm">Left Arrow</span>
                </Button>

                <Button
                  id="ndcTableBtnIdARTL AllRightArrow"
                  className="btn-primary"
                  onClick={() => actionNDCsMove('AllRightToLeft', null)}
                  tabIndex={0}
                  aria-label="AllRightArrow"
                >
                  <i className="fa fa-light fa-backward" aria-hidden="true" />
                  <span className="hide-elm">Right Arrow</span>
                </Button>
                <Button
                  id="ndcTableBtnIdRTL LeftArrow"
                  className="btn-primary"
                  onClick={() => actionNDCsMove('rightToLeft', 'RightGridData')}
                  tabIndex={0}
                  aria-label="LeftArrow"
                >
                  <i className="fa fa-light fa-caret-left" aria-hidden="true" />
                  <span className="hide-elm">Left Arrow</span>
                </Button>
              </div>
            )}
            {!fullScreenViewLeftGrid && (
              <div
                className={`ndcTable ndcTableRight ${
                  fullScreenViewRightGrid ? 'col-12' : ''
                }`}
              >
                <TableGridWithFeatures
                  ref={rightGridRef}
                  data-testid="ndcright-stc-table"
                  rowSelection="multiple"
                  rowMultiSelectWithClick={false}
                  fullScreenView={fullScreenViewRightGrid}
                  handleFullScreenViewClick={handleFullScreenViewRightGrid}
                  gridHeight="50vh"
                  rowData={rightGridData}
                  columnDefs={rightRebateProgramHead}
                  gridCall={onGridReadyRightGrid}
                  frameworkComponents={{
                    TextBoxRender: (cellInfo) => {
                      const name = cellInfo?.value;

                      if (name && name.length > 20) {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">{name}</Tooltip>
                            }
                          >
                            <div>{name}</div>
                          </OverlayTrigger>
                        );
                      }
                      return <div>{name}</div>;
                    },
                  }}
                  exportFile
                  animateRows
                  sideBar={false}
                  // eslint-disable-next-line react/destructuring-assignment
                  fileName="Rebate Programs Selected"
                  singleClickEdit
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  onSelectionChanged={onSelectionChangedRight}
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestDataNicheReportComponent;
